var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgGroup1242 = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.527.895H11.026C4.936.895 0 5.389 0 10.933v25.038C0 41.515 4.936 46.01 11.026 46.01h27.5c6.09 0 11.027-4.495 11.027-10.039V10.933C49.553 5.39 44.616.895 38.527.895Z",
    fill: "#FFC502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.034 22.788c1.536 0 2.782-1.134 2.782-2.533s-1.246-2.533-2.782-2.533c-1.537 0-2.783 1.134-2.783 2.533s1.246 2.533 2.783 2.533ZM34.521 22.788c1.537 0 2.783-1.134 2.783-2.533s-1.246-2.533-2.783-2.533c-1.536 0-2.782 1.134-2.782 2.533s1.246 2.533 2.782 2.533ZM40.485 29.185H9.07a.697.697 0 0 1-.47-.177.577.577 0 0 1-.193-.426c0-.16.07-.314.194-.427a.697.697 0 0 1 .469-.177h31.415c.176 0 .345.064.469.177a.578.578 0 0 1 .194.427c0 .16-.07.313-.194.426a.698.698 0 0 1-.469.177Z",
    fill: "#3B3735"
  })));
};
export { SvgGroup1242 as ReactComponent };
export default __webpack_public_path__ + "08dd6417659f2ec0dd2af8319033c98d.svg";